import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

import 'vuetify/dist/vuetify.min.css';
import fr from 'vuetify/es5/locale/fr';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { fr },
        current: 'fr'
    },
    icons: {
        iconfont: 'fa'
    },
    theme: {
        themes:
        {
            light: {
                primary: colors.blueGrey.darken1,
                'app-blue': colors.indigo.accent2,
                'app-red': colors.pink.lighten2,
                'app-green': colors.green.lighten1
            }
        }
    }
});
